<a class="project-card" [attr.data-date]="projectDate" routerLink="{{projectUrl}}">
    <img src="{{imageUrl}}">
    <div class="card-details">
        <h3>{{title}}</h3>
        <!-- <p>
            @for (division of divisions; track $index) { 
                @if ($index > 0) {/ {{division}} } @else { {{division}} }
            }
        </p> -->
        <a routerLink="{{projectUrl}}">View More</a>
    </div>
</a>